import React from 'react';
import styles from './UpcomingSessions.module.css';

const UpcomingSessions = ({ sessions, scheduleUrl }) => (
  <div className={styles.UpcomingSessions}>
    <div className={styles.Header}>
      <h3 className={styles.Title}>Upcoming Sessions</h3>
      {scheduleUrl && (
        <a
          href={scheduleUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.ScheduleLink}
        >
          Schedule &rarr;
        </a>
      )}
    </div>
    {sessions.length > 0 ? (
      sessions.map((session, i) => (
        <div key={i} className={styles.SessionRow}>
          <div className={styles.SessionTop}>
            <span className={styles.EventName}>{session.event_name}</span>
            <span className={styles.Date}>
              {new Date(session.service_date + 'T00:00:00').toLocaleDateString(
                undefined,
                { weekday: 'short', month: 'short', day: 'numeric' }
              )}
            </span>
          </div>
          {session.instructor_names && (
            <p className={styles.Instructor}>Coach: {session.instructor_names}</p>
          )}
        </div>
      ))
    ) : (
      <p className={styles.Empty}>No upcoming sessions</p>
    )}
  </div>
);

export default UpcomingSessions;
